$('#employee_search').keyup(function() {
    var searchstrings = $(this).val().toLowerCase().split(' ');
    $('.container_employee').each(function(employeeIndex, element) {
        var allNames = $(element).attr('attr-search').toLowerCase().split(' ');
        var all_found = searchstrings.reduce(function (accumulator, searchstring) {
            var found = false;
            $.each(allNames, function(nameIndex, name) {
                if (name.indexOf(searchstring) !== -1) {
                    found = true;
                    return false;
                }
            });
            return accumulator && found;
        }, true);
        all_found ? $(element).show() : $(element).hide();
    });
});